import React from "react";
import {useSelector} from "react-redux";
import {currencyFormat} from "../../../../utils/masks";
import TooltipDefault from "../../../TooltipDefault";
import {useTranslation} from "react-i18next";
import {
    DisciplineCard,
    CardHeaderBar,
    StatBody,
    StatRow,
} from "../styles";

export default function CardManagementSuccess({data}) {
    const {coinType} = useSelector((state) => state.BankReducer);
    const { t } = useTranslation();

    const assertiveness = parseFloat(
        (data.qtdeLoss + data.qtdeWin + data.qtdeDraw)
            ? data.qtdeWin * 100 / (data.qtdeLoss + data.qtdeWin + data.qtdeDraw)
            : 0
    ).toFixed(2);

    return (
        <DisciplineCard>
            <CardHeaderBar $variant="success">
                <span>{t('discipline_management_respected')}</span>
                <TooltipDefault
                    className="cursor-pointer"
                    title={t('discipline_management_respected_info')}
                >
                    <i className="fa fa-info-circle" aria-hidden="true"/>
                </TooltipDefault>
            </CardHeaderBar>
            <StatBody>
                <StatRow>
                    <span className="stat-label">{t('discipline_management_number_times')}</span>
                    <span className="stat-value">{data.qtdeDays ? data.qtdeDays : 0}</span>
                </StatRow>
                <StatRow>
                    <span className="stat-label">{t('discipline_management_draw_operations')}</span>
                    <span className="stat-value">{data.qtdeDraw ? data.qtdeDraw : 0}</span>
                </StatRow>
                <StatRow>
                    <span className="stat-label">{t('discipline_management_win_operations')}</span>
                    <span className="stat-value">{data.qtdeWin ? data.qtdeWin : 0}</span>
                </StatRow>
                <StatRow>
                    <span className="stat-label">{t('discipline_management_loss_operations')}</span>
                    <span className="stat-value">{data.qtdeLoss ? data.qtdeLoss : 0}</span>
                </StatRow>
                <StatRow>
                    <span className="stat-label">{t('discipline_management_assertiveness')}</span>
                    <span className="stat-value">{assertiveness}%</span>
                </StatRow>
                <StatRow>
                    <span className="stat-label">{t('discipline_management_profit_prejudice')}</span>
                    <span className="stat-value">
                        {coinType} {currencyFormat(data.profitObtained ? data.profitObtained : 0)}
                    </span>
                </StatRow>
            </StatBody>
        </DisciplineCard>
    );
}
